import { defineComponent, h, shallowRef, watch, watchEffect } from 'vue-demi';

import { isNumber, templateRef } from '@vueuse/core';

import { useRootInstance } from './utils/useRootInstance';
import { useIssueDetailEvents } from './warper/EventBusListener';
import { useUrlIssueIdCheck } from './warper/useUrlIssueIdCheck';
import { markCommentMessageRead } from './components/IssueDrawer/Api/comment';

export const TopAreaModeStorageKey = 'issue-detail-top-area-mode';
export interface CompatibleWarperInstance extends HTMLElement {
  showIssue: (
    id: number,
    defaultData: Record<string, any> | null,
    extendsData: { commentId?: number; subtaskId?: number }
  ) => void;
  closeIssue: () => void;
}

export default defineComponent({
  name: 'IssueDetailWarper',
  components: {
    CompatibleWarper: () =>
      import(
        '@issue-detail/components/IssueDrawer/Components/CompatibleWarper.vue'
      )
  },
  setup() {
    const instance = useRootInstance();
    const warper = templateRef<CompatibleWarperInstance>('warper');

    const component = shallowRef(null);

    const { issueId, projectId, commentId, source, reminderId, subtaskId } =
      useUrlIssueIdCheck();

    // watchEffect(() => {
    //   console.log('🚀🚀🚀🚀 issue detail init 🚀🚀🚀🚀', warper.value);
    // });

    useIssueDetailEvents(warper);

    watch(warper, (warper) => {
      if (warper && issueId && projectId) {
        warper?.showIssue(issueId, null, {
          commentId: commentId || undefined,
          subtaskId: subtaskId || undefined
        });
        instance.$track.send(
          'Issue_Visit',
          {
            source: source || '外链',
            top_state:
              (localStorage.getItem(TopAreaModeStorageKey) as
                | 'normal'
                | 'compact') || 'normal',
            Visit_Type: commentId ? '评论' : 'Issue本身'
          },
          true
        );

        if (reminderId && isNumber(reminderId)) {
          markCommentMessageRead(reminderId);
        }
      }
    });

    return () => h('CompatibleWarper', { ref: 'warper' });
  }
});
